import { render } from "./외국인방문취업진단서(H-2).vue?vue&type=template&id=22624285"
import script from "./외국인방문취업진단서(H-2).vue?vue&type=script&lang=js"
export * from "./외국인방문취업진단서(H-2).vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__